import React from 'react';
import './ToggleSwitchStyle.css';

function ToggleSwitch({ isOn, handleToggle, label = "Allow Distorted Data" }) {
  return (
    <div className="toggle-switch-container">
      <label className="toggle-switch-label">{label}</label>
      <label className="switch">
        <input type="checkbox" checked={isOn} onChange={handleToggle} />
        <span className="slider round"></span>
      </label>
    </div>
  );
}

export default ToggleSwitch;

